import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, StatusBadge, fmtDateTime } from "@/components/common";
import DataTable from "@/components/DataTable";
import AdvancedFilters from "@/components/AdvancedFilters";
import QuickFilters from "@/components/QuickFilters";
import { RecordingPlayer } from "@/components/RecordingPlayer";

const outcome = (r) => (r.answered ? "Connected" : "Not Connected");
const QF = [{ key: "counselor_name", label: "Counselors" }, { key: "direction", label: "Directions" }, { key: "disposition", label: "Dispositions" }, { key: "course", label: "Courses" }, { key: "outcome", label: "Outcomes", get: outcome }];

export default function Calls() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [quick, setQuick] = useState(null);
  const [display, setDisplay] = useState(null);
  useEffect(() => { api.get("/calls").then(({ data }) => setRows(data.map((r) => ({ ...r, outcome: outcome(r) })))); }, []);
  const FIELDS = useMemo(() => [
    { key: "student_name", label: "Student", type: "text" }, { key: "counselor_name", label: "Counselor", type: "text" },
    { key: "direction", label: "Direction", type: "select", options: ["Outbound", "Inbound"] }, { key: "disposition", label: "Disposition", type: "text" },
    { key: "outcome", label: "Outcome", type: "select", options: ["Connected", "Not Connected"] }, { key: "duration", label: "Duration (s)", type: "number" },
    { key: "notes", label: "Notes", type: "text" }, { key: "created_at", label: "Time", type: "date" },
  ], []);
  const columns = [
    { key: "student_name", label: "Student", fixed: true, render: (r) => <span className="font-semibold text-slate-800">{r.student_name || "—"}</span> },
    { key: "counselor_name", label: "Counselor" },
    { key: "direction", label: "Direction" },
    { key: "disposition", label: "Disposition", render: (r) => <span className="text-slate-700 font-medium">{r.disposition}</span> },
    { key: "outcome", label: "Outcome", render: (r) => <StatusBadge value={r.answered ? "Connected" : "Not Connected"} /> },
    { key: "duration", label: "Duration", render: (r) => `${Math.floor((r.duration || 0) / 60)}m ${(r.duration || 0) % 60}s` },
    { key: "notes", label: "Notes", render: (r) => <span className="text-xs text-slate-500">{r.notes || "—"}</span> },
    { key: "created_at", label: "Time", render: (r) => <span className="text-xs">{fmtDateTime(r.created_at)}</span> },
    { key: "recording_url", label: "Recording", render: (r) => <RecordingPlayer call={r} /> },
  ];
  return (
    <div>
      <PageHeader title="Calls" subtitle="Calls synced from counselors' phones (OHC CRM app) and logged in the CRM" testid="calls-header" />
      <QuickFilters rows={rows} fields={QF} onFiltered={setQuick} testid="calls" />
      <AdvancedFilters entity="calls" fields={FIELDS} rows={quick} onFiltered={setDisplay} />
      <DataTable columns={columns} rows={display} loading={rows === null} testid="calls-table" columnsKey="calls" onRowClick={(r) => r.student_id && navigate(`/students/${r.student_id}`)} empty="No calls logged yet" />
    </div>
  );
}
